/*
 * Latest-request guard.
 *
 * Every request takes a ticket; only the holder of the newest ticket may deliver its result.
 * A response that lands after a newer request was issued - the user paged again, re-sorted,
 * or the report was re-applied - is dropped instead of overwriting what the newer request is
 * about to show. invalidate() retires every ticket in flight without issuing a new one, for
 * when the data is being cleared rather than refetched.
 */
export type LatestRequestGuard = {
  begin: () => number;
  isLatest: (ticket: number) => boolean;
  invalidate: () => void;
};

export const createLatestRequestGuard = (): LatestRequestGuard => {
  let latest = 0;
  return {
    begin: () => ++latest,
    isLatest: (ticket) => ticket === latest,
    invalidate: () => { latest += 1; },
  };
};
